import { get } from "lodash";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player/youtube";
import useEnableScroll from "../../../custom-hooks/useEnableScroll";
import { api } from "../utils/InstanceAPI";
import LoadMore from "./LoadMore";
import NodeWrapper from "./NodeWrapper";
import TitleBar from "./TitleBar";
import { NO_WHEEL } from "./constants";
import styles from "./nodeTypeComponents.module.css";

export const initialVideoReportSize = {
  width: 385,
  height: 485,
};

const VideoNode = props => {
  const { enableScroll, mouseEnterLeave } = useEnableScroll();

  const playerWrapperRef = useRef(null);

  const [{ context, continuation, empty, key, items = [] } = {}, setVideoInfo] = useState();
  const [videoList, setVideoList] = useState([]);
  const [activeVideoUrl, setActiveVideoUrl] = useState();
  const [loading, setLoading] = useState(false);

  const { content = {}, resizeEventParams = {}, id, dragging, isOpenDeleteBox } = props;

  const { height = initialVideoReportSize.height, width = initialVideoReportSize.width } = resizeEventParams;

  const firstPageVideoInfo = useMemo(() => {
    let result = content;
    if (typeof content === "string") {
      try {
        result = JSON.parse(content);
      } catch (error) {
        console.log(error);
      }
    }
    return result;
  }, [content]);

  const handleClickSelectVideo = url => {
    setActiveVideoUrl(url);
  };

  const handleClickLoadMore = async () => {
    try {
      setLoading(true);

      const result = await api
        .post(`/be/svc-adapter/youtube/v2/search`, {
          context,
          continuation,
          key,
        })
        .then(response => response.json());

      setVideoInfo(result.data);
      setVideoList(list => [...list, ...result.data.items]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const resetVideoNodeState = useCallback(() => {
    setVideoInfo(firstPageVideoInfo);
    setVideoList(firstPageVideoInfo.items || []);
    setActiveVideoUrl(get(firstPageVideoInfo.items, [0, "url"]));
  }, [firstPageVideoInfo]);

  useEffect(() => {
    resetVideoNodeState();
  }, [firstPageVideoInfo]);

  useEffect(() => {
    if (playerWrapperRef.current) {
      const iframeNode = playerWrapperRef.current.querySelector("iframe");
      if (iframeNode) {
        iframeNode.style["pointer-events"] = dragging === true ? "none" : "auto";
      }
    }
  }, [dragging]);

  const { videoPlayerHeight, videoListHeight } = useMemo(
    () => ({
      videoPlayerHeight: (height - 40) * (6 / 13),
      videoListHeight: (height - 40) * (7 / 13),
    }),
    [height]
  );

  const noWheelClassName = enableScroll ? NO_WHEEL : "";

  return (
    <NodeWrapper
      mouseEnterLeave={mouseEnterLeave}
      style={{
        maxWidth: width,
        maxHeight: height,
      }}
    >
      {props.displayLabel ? (
        <TitleBar id={id} isOpenDeleteBox={isOpenDeleteBox}>
          Videos
        </TitleBar>
      ) : null}
      <div className={styles.scrollContent} ref={playerWrapperRef}>
        <ReactPlayer
          url={activeVideoUrl}
          width={"100%"}
          height={videoPlayerHeight}
          style={{ width: "100%", height: "100%" }}
          controls={true}
        />
        <div className={`${styles.scrollList} ${noWheelClassName}`} style={{ height: videoListHeight }}>
          {videoList.map(({ length, thumbnailUrl, title, url }) => {
            return (
              <div
                className={`${styles["video-item"]} ${activeVideoUrl === url ? styles["active"] : ""}`}
                onClick={() => handleClickSelectVideo(url)}
                style={{ maxWidth: 385 + width - initialVideoReportSize.width }}
                key={url}
              >
                <div className={styles["video-image"]}>
                  <img src={thumbnailUrl} alt="" />
                </div>
                <div className={styles["video-item-content"]}>
                  <div>{title}</div>
                  <span>{length}</span>
                </div>
              </div>
            );
          })}
          <LoadMore noMore={empty || items.length === 0} loading={loading} onClick={handleClickLoadMore} />
        </div>
      </div>
    </NodeWrapper>
  );
};

export default VideoNode;
